module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Once upon a time")]), _vm._v(", a Pisces bride was getting ready to celebrate her wedding. She wanted the fairy tale, the “walk out of the church surrounded by guests throwing rice” photo op. But this sensitive sign knew that it would be harmful to the innocent birds singing in the trees. “Birdseed!” this animal lover exclaimed. “That’s what the guests will toss!”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("As she and her bridesmaids sat over tea, one of them asked why they were wrapping little bundles of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("seeds")]), _vm._v(" in pretty pink pouches. With a smile she replied, “Geminis may like their guests to blow bubbles and Libras may like them to cast rose petals, but "), _c('em', {
    staticClass: "i"
  }, [_vm._v("never throw rice at a Pisces.")]), _vm._v("”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b36bb7a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429932165_fm02.vue
// module id = 69
// module chunks = 0